const content: { [key: string]: string } = {
  accountSelectorLabel: "Account selector",
  profile: "Profile",
  selectBusiness: "Select Business",
  resources: "Resources",
  selectLanguage: "Select Language",
  giveFeedback: "Give Feedback",
  logOut: "Log Out",
  back: "Back",
  gpv: "GPV",
  qualifiedLegs: "Qualified Legs",
  bonus: "Bonus",
  businessSelectorErrorHeadline: "Something went wrong",
  businessSelectorErrorContent: "Unable to load your businesses. Please try again later.",
  confidentialTooltip: "This user is confidential and cannot be selected.",
};

export default content;
